import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../../Config";
import Anonymous from "../../../../../../Assets/Images/Anonymous.svg";

const RecentViewedCard = (props) => {
  const [JPAType, setJPAType] = useState("");
  const [Details, setDetails] = useState();
  const [IsSaved, setIsSaved] = useState(false);

  useEffect(() => {
    if (props.Data.position) {
      setJPAType("Job");
      setDetails({
        bookmarked: props.Data.bookmarked,
        id: props.Data.id,
        reactionType: props.Data.reactionType,
        title: props.Data.position.title,
        location: props.Data.position.workCity,
        people: props.Data.mostEmployees,
      });
      setIsSaved(props.Data.bookmarked);
    } else if (props.Data.project) {
      setJPAType("Project");
      setDetails({
        bookmarked: props.Data.bookmarked,
        id: props.Data.id,
        reactionType: props.Data.reactionType,
        title: props.Data.project.title,
        location: props.Data.project.workCity,
        people: props.Data.mostEmployees,
      });
      setIsSaved(props.Data.bookmarked);
    } else {
      setJPAType("Activity");
      setDetails({
        bookmarked: props.Data.bookmarked,
        id: props.Data.id,
        reactionType: props.Data.reactionType,
        title: props.Data.activity.title,
        location: props.Data.activity.workCity,
        people: props.Data.mostEmployees,
      });
      setIsSaved(props.Data.bookmarked);
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortentTitle = (Title) => {
    if (Title.length < 25) {
      return Title;
    } else {
      return Title.slice(0, 21) + " ...";
    }
  };

  const toggleLike = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "LIKE",
    };

    if (props.Data.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.projectRecommendationId = props.Data.id;
    } else if (props.Data.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.activityRecommendationId = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Data.id;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshJPAs();
        if (
          document
            .getElementById(props.Id + "-like")
            .classList.contains("overlayed") ||
          document
            .getElementById(props.Id + "-like")
            .classList.contains("overlayed-no-animation")
        ) {
          document
            .getElementById(props.Id + "-like")
            .classList.remove("overlayed", "overlayed-no-animation");
        } else {
          document
            .getElementById(props.Id + "-dislike")
            .classList.remove("overlayed", "overlayed-no-animation");
          document
            .getElementById(props.Id + "-like")
            .classList.add("overlayed", "overlayed-no-animation");
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleDislike = () => {
    let ActionURL;
    let ActionType;
    let Data = {
      reactionType: "DISLIKE",
    };

    if (props.Data.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.projectRecommendationId = props.Data.id;
    } else if (props.Data.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.activityRecommendationId = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Data.id;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/reaction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshJPAs();
        if (
          document
            .getElementById(props.Id + "-dislike")
            .classList.contains("overlayed") ||
          document
            .getElementById(props.Id + "-dislike")
            .classList.contains("overlayed-no-animation")
        ) {
          document
            .getElementById(props.Id + "-dislike")
            .classList.remove("overlayed", "overlayed-no-animation");
        } else {
          document
            .getElementById(props.Id + "-dislike")
            .classList.add("overlayed", "overlayed-no-animation");
          document
            .getElementById(props.Id + "-like")
            .classList.remove("overlayed", "overlayed-no-animation");
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleSave = () => {
    let ActionURL;
    let ActionType;
    let Data = {};
    if (props.Data.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
      Data.recommendationId = props.Data.id;
    } else if (props.Data.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
      Data.recommendationId = props.Data.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.positionRecommendationId = props.Data.id;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/recommendation/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-type": "application/json",
      },
      data: Data,
    };
    setIsSaved(!IsSaved);
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshJPAs();
        if (
          document
            .getElementById(props.Id + "-save")
            .classList.contains("saved") ||
          document
            .getElementById(props.Id + "-save")
            .classList.contains("saved-no-animation")
        ) {
          document
            .getElementById(props.Id + "-save")
            .classList.remove("saved", "saved-no-animation");
        } else {
          document
            .getElementById(props.Id + "-save")
            .classList.add("saved", "saved-no-animation");
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const replaceAvatar = (Person) => {
    if (Person.revealIdentity || Person.id === props.UserInfo.id) {
      if (Person.imageThumbnailUrl === null) {
        return (
          <div
            className="avatar-placeholder"
            style={{ backgroundColor: Person.backgroundColorCode }}
          >
            <p style={{ color: Person.textColorCode }}>
              {Person.firstName.slice(0, 1).toUpperCase()}
            </p>
          </div>
        );
      } else {
        return (
          <div className="avatar-placeholder">
            <img
              className="small-avatar"
              alt=""
              src={Person.imageThumbnailUrl}
            />
          </div>
        );
      }
    } else {
      return (
        <div className="avatar-placeholder anonymous-avatar">
          <img className="small-avatar" alt="" src={Anonymous} />
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      {Details ? (
        <div className="recent-item">
          <h1 className="item-title">
            {shortentTitle(Details.title)}
            {Details.title.length > 25 ? <p>{Details.title}</p> : null}
          </h1>
          <p className="item-location">{Details.location}</p>
          <p className="item-type">{JPAType}</p>
          <button
            className={
              Details.bookmarked ? "bookmark saved-no-animation" : "bookmark"
            }
            onClick={() => toggleSave()}
            id={props.Id + "-save"}
          >
            <i className="feather-bookmark"></i>
            <i className="feather-plus"></i>
            {IsSaved ? (
              <p className="popup-text">{translateText("unsave")}</p>
            ) : (
              <p className="popup-text">{translateText("save")}</p>
            )}
          </button>
          <span
            id={props.Id + "-dislike"}
            onClick={() => toggleDislike()}
            className={
              Details.reactionType === "DISLIKE"
                ? "item-action-rounded dislike overlayed-no-animation"
                : "item-action-rounded dislike"
            }
          >
            <i className="feather-thumbs-down"></i>
            <p className="popup-text">{translateText("dislike")}</p>
          </span>
          <span
            id={props.Id + "-like"}
            onClick={() => toggleLike()}
            className={
              Details.reactionType === "LIKE"
                ? "item-action-rounded like overlayed-no-animation"
                : "item-action-rounded like"
            }
          >
            <i className="feather-thumbs-up"></i>
            <p className="popup-text">{translateText("like")}</p>
          </span>
          {Details.people ? (
            <section className="people">
              {Details.people.map((Person, i) => (
                <span className="person" key={i}>
                  {replaceAvatar(Person)}
                </span>
              ))}
              {Details.people.length < 4 ? (
                <span
                  className="person"
                  style={{ background: "transparent" }}
                ></span>
              ) : (
                <span className="person">+2</span>
              )}
            </section>
          ) : null}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default RecentViewedCard;
